import ApiService from './ApiService'

class RoleService {
  static async getRoles () {
    return ApiService.GET('/api/roles/index')
  }

  static async getRole (roleId) {
    return ApiService.GET(`/api/roles/view/${roleId}`)
  }

  static async deleteRole (roleId) {
    return ApiService.POST(`/api/roles/delete/${roleId}`)
  }

  static async createRole (data) {
    return ApiService.POST('/api/roles/create', data)
  }

  static async editRole (roleId, data) {
    return ApiService.POST(`/api/roles/edit/${roleId}`, data)
  }
}

export default RoleService
